import { type FC } from 'react'

import type { ProspectAuditOnlyFansDto } from '@api'
import { Image, Link, Text, View } from '@react-pdf/renderer'
import Html from 'react-pdf-html'

import launchImage from '@/assets/images/launch.png'
import { extractUsername } from '@/utils/socials'

import { styles as commonStyles } from '../styles'
import { formatLikes } from '../utils'
import { styles } from './styles'

interface Props {
  data: ProspectAuditOnlyFansDto
}

export const OfAuditBlock: FC<Props> = ({ data }) => {
  if (!data.accountUrl) {
    return null
  }

  return (
    <View
      style={commonStyles.block}
      wrap={false}
    >
      <Text style={commonStyles.title}>OnlyFans</Text>
      <View style={commonStyles.header}>
        <View style={[commonStyles.card, styles.leftBlock]}>
          <View style={styles.account}>
            <View style={[commonStyles.accountWrapper, styles.accountWrapper]}>
              {data.avatarUrl && (
                <Image
                  src={data.avatarUrl}
                  style={commonStyles.avatar}
                />
              )}
              <View>
                <Text style={commonStyles.accountName}>
                  @{extractUsername(data.accountUrl)}
                </Text>
                <View style={commonStyles.linkWrapper}>
                  <Link
                    src={data.accountUrl}
                    style={commonStyles.link}
                  >
                    View on OnlyFans
                  </Link>
                  <Image
                    src={launchImage}
                    style={commonStyles.linkIcon}
                  />
                </View>
              </View>
            </View>
            {data.bio && (
              <View style={styles.bioWrapper}>
                <Html style={styles.bio}>{data.bio}</Html>
              </View>
            )}
          </View>
        </View>

        <View style={styles.rightBlock}>
          <View style={commonStyles.card}>
            <View style={styles.metrics}>
              <View style={commonStyles.flex}>
                <Text style={styles.metricLabel}>Posts</Text>
                <Text style={styles.metricValue}>{data.postsCount || 0}</Text>
              </View>
              <View style={styles.metricSeparator} />
              <View style={commonStyles.flex}>
                <Text style={styles.metricLabel}>Likes</Text>
                <Text style={styles.metricValue}>
                  {formatLikes(data.likesCount)}
                </Text>
              </View>
            </View>
          </View>
          {!!data.promotionPercentage && (
            <View style={commonStyles.card}>
              <Text style={[commonStyles.headerTitle, styles.promoTitle]}>
                Promotion
              </Text>
              <Text style={styles.metricLabel}>Current Promotion Discount</Text>
              <View>
                <Text style={styles.discount}>
                  {data.promotionPercentage}% off
                </Text>
              </View>
            </View>
          )}
        </View>
      </View>
    </View>
  )
}
